/* eslint-disable camelcase */
import moment from 'moment';
import { sendAdjustIntiateChekout } from './Adjust';
import { getAsterCategory, getMyAsterCategory } from './common-utils';
import {
  ADJUST_EVENT_TOKENS,
  ASTER_PRODUCT_TYPES,
  ASTER_PURCHASE_TYPES,
  GET_HOST_COUNTRY,
  ONE_ASTER_CATEGORY,
  SCREEN_NAME,
} from './constants';
import { convertDateToServer, convertUtcToGst } from './date-utils';
import { sendEventToSmartLook } from './smartlook';
import { getCurrency, getLanguage, getRegionName, MY_ASTER_CATEGORY, PAGE_NAME, PAGE_TYPE } from '@common/Constants/analytics';
import { clearDataLayerParams } from "./gtm-params-cleanup";
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { getLangCodeFromUrl, getRegionCodeFromUrl } from '../../../i18n';
import { getAnalyticsState } from './analytics-common';

export const dataLayerSendEvent = (eventName, additionalParams = {}) => {
  const { screenName, pageType, myAsterCategory } = getAnalyticsState() || {};
  const { screen_name, page_type, myaster_category, ...rest } = additionalParams;
  const langCode = getLangCodeFromUrl();
  const regionCode = getRegionCodeFromUrl(true);
  const combinedParams = {
    screen_name: screen_name || screenName,
    page_type: page_type || pageType,
    myaster_category: myaster_category || myAsterCategory,
    selected_country: getRegionName(regionCode),
    content_language: getLanguage(langCode),
  };
  clearDataLayerParams();

  
  const dataLayerOptions = {
    event: eventName,
    ...combinedParams,
    ...rest,
  };
  // eslint-disable-next-line no-unused-expressions
  typeof window !== 'undefined' ? window.dataLayer?.push(dataLayerOptions) : '';
};

export const sendBeginCheckoutEvent = (data, type, referrerPage = '') => {
  const productItemData = {
    currency: 'AED',
    purchase_type: ASTER_PURCHASE_TYPES.DOCTOR,
    referrerpage: referrerPage,
    booking_type: type,
    page_type: 'Checkout Page',
    service_type: null,
    coupon: '',
    doctor_name: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
    speciality: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
    screen_name: 'Checkout Page',
    appointment_date: convertDateToServer(data?.start),
    appointment_time: moment(data?.start).format('HH:mm:ss'),
    date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    appointment_mode:
      data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
        ? 'Video Consultation'
        : 'In-Person Consultation',
    hospital_name: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
    distance: data?.participant
      ?.find((x) => x.actor.type === 'Location')
      ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
    visit_type: data?.extension?.find((x) => x?.url === 'visitParticulars')?.valueString,
    payment_amount:
      data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString === undefined
        ? '0'
        : Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
    booking_id: data?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
    value:
      data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString === undefined
        ? '0'
        : data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString,
    ecommerce: {
      items: [
        {
          item_id: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
          item_name: data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString,
          coupon: '',
          currency: 'AED',
          discount: 0,
          index: '',
          item_category: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
          item_list_name: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
          price:
            data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString === undefined
              ? '0'
              : data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString,
          quantity: 1,
        },
      ],
    },
  };
  dataLayerSendEvent('begin_checkout', productItemData);
  const properties = {
    type: productItemData,
  };
  sendAdjustIntiateChekout(ADJUST_EVENT_TOKENS.INITIATE_CHECKOUT, productItemData?.ecommerce?.items?.[0].item_category);
};

const getPaymentType = (data) => {
  if (data === 'Pay at Clinic') {
    return 'Pay at Clinic';
  } else {
    if (data?.isPaymentCardExists) {
      return 'SAVED CARD';
    } else {
      return 'Pay via Credit/Debit Card';
    }
  }
};

const getFacilityNames = (data) => {
  const facilityNames = data.slice(1).map((facility) => facility?.facilityName);
  return facilityNames;
};

export const getDoctorsListObject = (doctor) => {
  return {
    item_id: doctor?.id,
    item_name: doctor?.name,
    coupon: '',
    currency: '',
    discount: 0,
    index: '',
    item_brand: '',
    item_category: doctor?.specialization,
    item_list_id: '',
    item_list_name: doctor?.facilityDetails?.[0]?.facilityName,
    price: '',
    quantity: 1,
  };
};

export const getClincsItemObject = (clinic) => {
  return {
    item_id: clinic?.id,
    item_name: clinic?.name,
    coupon: '',
    currency: 'AED',
    discount: 0,
    index: '',
    item_brand: '',
    item_category: clinic?.clinicType,
    item_list_id: '',
    item_list_name: 'Clinics Nearby You',
    price: '',
    quantity: 1,
  };
};

export const sendSelectItemEvent = (item, sectionName, type) => {
  const itemData = {
    item_list_id: '',
    item_list_name: sectionName,
    section_name: sectionName,
    product_type: ONE_ASTER_CATEGORY.DOCTOR,
    ecommerce: {
      items: type === 'Doctor' ? getDoctorsListObject(item) : getClincsItemObject(item),
    },
    currency: getCurrency(getDataFromCookie('regionCode')),
  };

  dataLayerSendEvent('select_item', itemData);
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('select_item', properties);
};

export const sendViewItemListEvent = (items, sectionName) => {
  const itemData = {
    item_list_id: '',
    item_list_name: sectionName,
    section_name: sectionName,
    product_type: ASTER_PRODUCT_TYPES?.DOCTOR,
    ecommerce: {
      items: items,
    },
  };

  dataLayerSendEvent('view_item_list', itemData);
  // const properties = {
  //   type: trending?.offerType,
  // };
  // sendEventToSmartLook('view_item_list', properties);
};

export const sendPageViewEvent = (screenName, category, pageType, userLogin, referrerPage = '') => {
  const userArea = localStorage.getItem('userArea');
  const userZone = localStorage.getItem('userZone');
  const itemData = {
    screen_name: screenName,
    oneaster_category: category,
    page_type: pageType,
    user_state: userLogin !== undefined ? 'Logged In' : 'Guest',
    user_area: userArea,
    user_pharmacy_zone: String(userZone)?.split(','),
    referrer_page: referrerPage,
  };

  dataLayerSendEvent('page_view', itemData);
};

export const sendPageviewEvent = (
  screenName,
  category,
  pageType,
  referrerPage = '',
  pageId = '',
  noOfDoctors = '',
  isReportInProgress = false,
) => {
  const itemData = {
    screen_name: screenName,
    myaster_category: category,
    page_type: pageType,
    ...(pageId ? { page_id: pageId } : {}),
    ...(referrerPage ? { referrer_page: referrerPage } : {}),
    ...(noOfDoctors ? { number_of_doctors: noOfDoctors } : {}),
    ...(isReportInProgress ? { is_report_in_progress: isReportInProgress } : {}),
  };

  dataLayerSendEvent('page_view', itemData);
};

export const sendAppointmentPageviewEvent = (screenName, category, pageType, option) => {
  const itemData = {
    screen_name: screenName,
    myaster_category: category,
    page_type: pageType,
    option: option,
  };

  dataLayerSendEvent('page_view', itemData);
};

export const sendListingPageviewEvent = (screenName, category, pageType, referrerPage, pageId, noOfDoctors = '') => {
  const itemData = {
    screen_name: screenName,
    myaster_category: category,
    page_type: pageType,
    ...(pageId ? { page_id: pageId } : {}),
    ...(referrerPage ? { referrer_page: referrerPage } : {}),
    number_of_doctors: noOfDoctors,
  };

  dataLayerSendEvent('page_view', itemData);
};

export const sendDetailsPageViewEvent = (
  screenName,
  category,
  pageType,
  userLogin,
  referrerPage = '',
  doctorDetail,
  slots,
) => {
  let lastSlot = '';
  for (let i = slots?.length - 1; i >= 0; i--) {
    if (slots[i]?.statusText === 'Available') {
      lastSlot = convertUtcToGst(slots?.[i]?.startTime);
      break;
    }
  }
  const userArea = localStorage.getItem('userArea');
  const userZone = localStorage.getItem('userZone');
  const itemData = {
    screen_name: screenName,
    section_shown: screenName,
    oneaster_category: category,
    page_type: pageType,
    user_state: userLogin ? 'Logged In' : 'Guest',
    user_area: userArea,
    user_pharmacy_zone: String(userZone)?.split(','),
    referrer_page: referrerPage,
    pid: doctorDetail?.vcpId,
    other_facility_name:
      doctorDetail?.attributes?.facilityList?.length > 1
        ? getFacilityNames(doctorDetail?.attributes?.facilityList)
        : [],
    doctor_availability_video_consultation: !!(
      doctorDetail?.attributes?.consultationType === 'BOTH' || doctorDetail?.attributes?.consultationType === 'ONLINE'
    ),
    last_appointment_slot: lastSlot,
    doctor_name: doctorDetail?.attributes?.fullName,
    speciality: doctorDetail?.attributes?.primarySpeciality,
    appointment_mode:
      doctorDetail?.attributes?.consultationType === 'BOTH'
        ? 'In-Person & Video Consultation'
        : doctorDetail?.attributes?.consultationType === 'IN-PERSON'
        ? 'In-Person Consultation'
        : 'Video Consultation',
    hospital_name: doctorDetail?.attributes?.facilityList?.[0]?.facilityName,
    _clear: true,
  };
  dataLayerSendEvent('page_view', itemData);
};

export const sendLoginEvent = (screenName, pageType, asPath) => {
  const path = asPath?.split('/');
  const category = getAsterCategory(path);

  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    referrer_page: pageType,
    myaster_category: category,
  };

  dataLayerSendEvent('login_register_initiation', itemData);
};


export const sendClinicClickEvent = (screenName, detail) => {

  const getScreenName = () => {
    if (screenName === 'Core') {
      return SCREEN_NAME?.ASCO;
    } else if (screenName === 'clinics listing') {
      return SCREEN_NAME?.CLINIC_LIST;
    } else {
      return SCREEN_NAME?.AT;
    }
  };

  const getPageType = () => {
    if (screenName === 'clinics listing') {
      return PAGE_TYPE?.CLINIC_LISTING_PAGE;
    } else {
      return PAGE_TYPE?.HOME;
    }
  }
  const itemData = {
    screen_name: getScreenName(),
    page_type: getPageType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    facility_name: detail?.name,
    facility_id: detail?.facilityId,
    facility_type: detail?.facilityType?.toLowerCase(),
  };

  dataLayerSendEvent('facility_click', itemData);
  sendEventToSmartLook('facility_click', itemData);
};

export const sendViewRecordEvent = (item, screenType) => {
  const speciality = item?.resource?.participant?.[0]?.individual?.extension?.find(
    (item) => item.url === 'Specialization',
  )?.valueString;
  const reportType = item?.resource?.type?.[0]?.text;
  const serviceType = item?.resource?.type?.[0]?.coding?.[0]?.code === "In-Person Consultation" ? 'in-person consultation' : 'video consultation' ;

  const getScreenName = () => {
    if(screenType === 'prescription') return 'records prescription ';
    else if(screenType === 'lab') return 'records lab';
    else if(screenType === 'scan') return 'records scan';
  };

  const getTabName =() => {
    if(screenType === 'prescription') return 'prescriptions';
    else if(screenType === 'lab') return 'lab reports';
    else if(screenType === 'scan') return 'scan reports';
    return '';
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: PAGE_TYPE?.RECORDS_PAGE,   
    tab_name: getTabName(),
    record_type: reportType,
    facility_name: item?.resource?.location?.[0]?.location?.display,
    appointment_mode: reportType === 'Prescription' ? serviceType : '',
    appointment_id: item?.resource?.id,
    speciality,
    doctor_name: item?.resource?.participant?.[0]?.individual?.display,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT, 
  };

  dataLayerSendEvent('view_record', itemData);

  const itemDataInsider = {
    record_type: reportType,
    doctor_name: item?.resource?.participant?.[0]?.individual?.display,
    speciality,
    hospital_name: item?.resource?.location?.[0]?.location?.display,
    appointment_mode: reportType === 'Prescription' ? serviceType : '',
    facility_type: item?.resource?.extension?.find((i) => i.url === 'facilityType')?.valueString,
  };
  const properties = {
    type: itemDataInsider,
  };
  sendEventToSmartLook('view_record', properties);
};

export const dataLayerPageViewRecord = (event, screen_name, dropdown, pageReferrer = '') => {
  const userArea = localStorage.getItem('userArea');
  const userZone = localStorage.getItem('userZone');
  const params = {
    ...(dropdown ? { option: dropdown } : {}),
    oneaster_category: ONE_ASTER_CATEGORY.CORE,
    screen_name,
    page_type: screen_name,
    user_area: userArea,
    user_pharmacy_zone: String(userZone)?.split(','),
    page_referrer: pageReferrer,
  };
  dataLayerSendEvent(event, params);
};

export const noRecordsFound = (screen, tab, dropdown, type) => {
  const screenName = () => {
    if (screen === 'prescription') {
      return 'records prescription';
    } else if (screen === 'lab') {
      return 'records lab';
    } else if (screen === 'scan') {
      return 'records scan';
    } else {
      return 'main records';
    }
  };

  const tabName = () => {
    if (tab === 'prescription') {
      return 'prescriptions';
    } else if (tab === 'lab') {
      return 'lab reports';
    } else if (tab === 'scan') {
      return 'scan reports';
    } else {
      return tab.toLowerCase();
    }
  };

  const itemData = {
    screen_name: screenName(),
    page_type: 'records page',
    tab_name: tabName(),
    option: dropdown,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    type: type,
  };
  dataLayerSendEvent('no_records_found', itemData);
};

export const sendOrderPrescriptionEvent = (details) => {
  const itemData = {
    doctor_name: details?.doctor_name,
    speciality: details?.speciality,
    hospital_name: details?.hospital_name,
    appointment_mode: details?.consultation_type,
    facility_type: '',
  };

  dataLayerSendEvent('order_prescription', itemData);

  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('order_prescription', properties);
};

export const sendJoinConsultationEvent = (details, cdmProps) => {
  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type: PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: details?.doctorData?.actor?.display,
    speciality: details?.doctorSpecialization,
    facility_name: details?.location?.actor?.display,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    booking_id: details?.hisSystem?.valueIdentifier?.value,
    appointment_date: convertDateToServer(details?.startTime),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    insurance_name: details?.insuranceName || '',
    insurance_network: details?.insuranceNetwork || '',
    appointment_id: details?.appointmentId,
    cdp_covered: details?.isCDP?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };

  dataLayerSendEvent('join_consultation', itemData);
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('join_consultation', properties);
};

export const sendEndConsultationEvent = (details, duration, cdmProps) => {
  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type: PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: details?.doctorData?.actor?.display,
    speciality: details?.doctorSpecialization,
    facility_name: details?.location?.actor?.display,
    call_duration: duration,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    booking_id: details?.hisSystem?.valueIdentifier?.value,
    appointment_date: convertDateToServer(details?.startTime),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    insurance_name: details?.insuranceName || '',
    insurance_network: details?.insuranceNetwork || '',
    appointment_id: details?.appointmentId,
    cdp_covered: details?.isCDP?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };

  dataLayerSendEvent('end_consultation', itemData);
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('end_consultation', properties);
};

const getEventData = (data) => {
  return {
    page_type: data?.page_type,
    screen_name: data?.screen_name,
    availability: data?.availability ? data?.availability : null,
    filter_consultation_date: data?.filter_consultation_date ? data?.filter_consultation_date : '',
    filter_practitioner_gender: data?.filter_practitioner_gender ? data?.filter_practitioner_gender : '',
    filter_facilityType: data?.filter_facilityType ? data?.filter_facilityType : null,
    filter_facility: data?.filter_facility ? data?.filter_facility : null,
    filter_practitioner_language: data?.filter_practitioner_language ? data?.filter_practitioner_language : '',
    sort_by: data?.sort_by ? data?.sort_by : '',
  };
};

export const sendFilterClickEvent = (page, screen, state) => {
  const itemData = {
    page_type: page,
    screen_name: screen,
  };
  const availabltityStatus = [];
  if (state.isAvailableToday) {
    availabltityStatus.push('Today');
  }
  if (state.isConsultOnline) {
    availabltityStatus.push('Video Consultation');
  }
  if (availabltityStatus.length > 0) {
    itemData.availability = availabltityStatus;
  }
  if (state.consultAvailable && state.consultAvailable !== '')
    itemData.filter_consultation_date = state.consultAvailable;
  if (state.gender && state.gender !== '') itemData.filter_practitioner_gender = state.gender;
  if (state.facilityType && state.facilityType?.length > 0) itemData.filter_facilityType = state.facilityType;
  if (state.facility && state.facility?.length > 0) itemData.filter_facility = state.facility;
  if (state.languages && state.languages !== '') itemData.filter_practitioner_language = state.languages;
  if (state.sort && state.sort !== '') itemData.sort_by = state.sort;

  if (Object.keys(itemData).length > 2) {
    const data = getEventData(itemData);
    dataLayerSendEvent('filter_click', data);
  }
};

export const sendClearFiltersEvent = (page, screen) => {
  const itemData = {
    page_type: page,
    screen_name: screen,
  };

  dataLayerSendEvent('clear_filters', itemData);
};

export const sendEnterWaitingRoomEvent = (data) => {
  const itemData = {
    screen_name: 'Waiting Room',
    oneaster_category: ONE_ASTER_CATEGORY.DOCTOR,
    doctor_name: data?.doctorName,
    speciality: data?.doctorSpecialty,
    hospital_name: data?.facilityName,
    payment_method: data?.payerType,
    facility_type: data?.facilityType,
    appointment_date: data?.appointmentDate,
    appointment_time: data?.appointmentTime,
    date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    booking_id: data?.hisSystem.valueIdentifier?.value,
  };
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('enter_waiting_room', properties);
};

export const sendJoinConsultationErrorEvent = (details) => {
  const itemData = {
    error: 'Join Consultation Error',
    screen_name: 'Waiting Room',
    oneaster_category: ONE_ASTER_CATEGORY.DOCTOR,
    doctor_name: details?.doctorData?.actor?.display,
    speciality: details?.doctorSpecialization,
    hospital_name: details?.location?.actor?.display,
    payment_method: details?.paymentMethod,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    booking_id: details?.appointmentId,
    appointment_date: convertDateToServer(details?.startTime),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  };

  dataLayerSendEvent('join_consultation_error', itemData);
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('join_consultation_error', properties);
};

export const sendEnterWaitingRoomErrorEvent = (data) => {
  const itemData = {
    error: 'Waiting Room Error',
    screen_name: 'Waiting Room',
    oneaster_category: ONE_ASTER_CATEGORY.DOCTOR,
    doctor_name: data?.doctorData?.actor?.display,
    speciality: data?.doctorSpecialization,
    hospital_name: data?.location?.actor?.display,
    payment_method: data?.paymentMethod,
    facility_type: data?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    appointment_date: convertDateToServer(data?.startTime),
    appointment_time: moment(data?.startTime).format('HH:mm:ss'),
    date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    booking_id: data?.hisSystem.valueIdentifier?.value,
  };
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('enter_waiting_room_error', properties);
};

export const sendHISConnectorFailEvent = (data) => {
  const itemData = {
    doctor_name: data?.doctorName,
    speciality: data?.doctorSpecialty,
    facility_type: data?.facilityType,
    hospital_name: data?.facilityName,
    error: 'doctor HISID conflict error',
    screen_name: 'Checkout Screen',
    facility_id: data?.facilityId,
    booking_type:
      data?.extension?.find((x) => x?.url === 'appointmentCategory')?.valueString === 'quickBooking'
        ? 'Quick Booking'
        : 'Standard Booking',
    date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  };
  dataLayerSendEvent('book_appointment_error', itemData);
  const properties = {
    type: itemData,
  };
  sendEventToSmartLook('book_appointment_error', properties);
};

export const dataLayerAddFamilyMemberinitiation = (screenName, pageType, myAsterCategory, referrerPage, pageId) => {
  const parameter = {
    screen_name: screenName,
    myaster_category: myAsterCategory,
    referrer_page: referrerPage,
    page_type: pageType,
    ...(pageId ? { page_id: pageId } : {}),
  };
  dataLayerSendEvent('add_family_member_initiation', parameter);
};

export const dataLayerAddFamilyMemberSuccess = (screenName, pageType, myAsterCategory, refererPage, pageId) => {
  const parameter = {
    screen_name: screenName,
    myaster_category: myAsterCategory,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage } : {}),
    ...(pageId ? { page_id: pageId } : {}),
  };
  dataLayerSendEvent('add_family_member_success', parameter);
};

export const dataLayerAddFamilyMemberError = (
  screenName,
  pageType,
  myAsterCategory,
  refererPage,
  error,
  errType,
  pageId,
) => {
  const parameter = {
    screen_name: screenName,
    myaster_category: myAsterCategory,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage } : {}),
    ...(pageId ? { page_id: pageId } : {}),
    error: error,
    err_type: errType,
  };
  dataLayerSendEvent('add_family_member_error', parameter);
};

export const dataLayerSendKeycloakData = ({
  event,
  userLocation,
  screenName,
  referrerPage,
  oneAsterCategory = 'Aster core',
  countryCode,
  error,
  initiationSource,
}) => {
  const params = {
    oneaster_category: oneAsterCategory,
    screen_name: screenName,
    user_area: userLocation?.area,
    user_pharmacy_zone: userLocation?.zone?.[0],
  };

  if (referrerPage) {
    params.referrer_page = referrerPage;
  }

  if (initiationSource) {
    params.initiation_source = initiationSource;
  }

  if (countryCode) {
    params.country_code = countryCode;
  }

  if (error) {
    params.error = error;
  }

  dataLayerSendEvent(event, params);
};

export const clickInteractionQuickLink = (Selection) => {
  const paramater = {
    screen_name: SCREEN_NAME?.ASCO,
    page_type: PAGE_TYPE?.HOME,
    myaster_category: MY_ASTER_CATEGORY?.ASCO,
    selection: Selection,

  };
  dataLayerSendEvent('quick_link_click', paramater);
};

export const epharmacyHomeImpression = (screenName, pageType, bannerId, bannerTitle, bannerUrl, pageReferrer) => {
  const parameter = {
    screen_name: screenName,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    referrer_page: pageReferrer,
    banner_id: bannerId,
    banner_title: bannerTitle,
    banner_page_slot: 'Bottom',
    banner_url: bannerUrl,
    banner_name: 'Cross sell banner',
  };
  dataLayerSendEvent('banner_impression', parameter);
};

export const epharmacyBannerClick = (screenName, pageType, bannerId, bannerTitle, bannerUrl, pageReferrer) => {
  const parameter = {
    screen_name: screenName,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    referrer_page: pageReferrer,
    banner_id: bannerId,
    banner_title: bannerTitle,
    banner_page_slot: 'Bottom',
    banner_url: bannerUrl,
    banner_name: 'Cross sell banner',
  };
  dataLayerSendEvent('banner_click', parameter);
};

export const sendManualSyncEvent = ({ eventName, source, screen, tab, selectedFilter, error }) => {
  const getTabName = (tab) => {
    if (tab === 'Video Consultation') {
      return 'video';
    } else if (tab === 'prescription') {
      return 'prescriptions';
    } else if (tab === 'lab') {
      return 'lab reports';
    } else if (tab === 'scan') {
      return 'scan reports';
    } else if (tab === 'HOME') {
      return 'homecare';
    } else {
      return tab.toLowerCase();
    }
  };

  const getScreenName = (screen) => {
    let screenName = '';
    if (screen === undefined || screen === null) {
      if (source === 'appointment') {
        screenName = 'appointments';
      } else {
        screenName = 'main records';
      }
    } else {
      if (screen === 'prescription') {
        screenName = 'records prescription';
      } else if (screen === 'lab') {
        screenName = 'records lab';
      } else if (screen === 'scan') {
        screenName = 'records scan';
      } else if (screen === 'In-Person') {
        screenName = 'appointments in-person';
      } else if (screen === 'Video Consultation') {
        screenName = 'appointments video';
      } else if (screen === 'All') {
        screenName = 'appointments all';
      } else if (screen === 'HOME') {
        screenName = 'appointments homecare';
      }
    }
    return screenName;
  };

  const getOptionValue = () => {
    let option = '';
    if (source === 'appointment') {
      if (selectedFilter === 'UPCOMING') {
        option = 'Upcoming';
      } else if (selectedFilter === 'PAST') {
        option = 'Past';
      }
    } else if (source === 'records') {
      if (selectedFilter === '1') {
        option = 'Last Month';
      } else if (selectedFilter === '3') {
        option = 'Last 3 Months';
      } else if (selectedFilter === '6') {
        option = 'Last 6 Months';
      } else if (selectedFilter === '0') {
        option = 'Any Time';
      }
    }
    return option;
  };
  const parameter = {
    screen_name: getScreenName(screen),
    page_type: source === 'appointment' ? 'appointments page' : 'records page',
    tab_name: getTabName(tab),
    option: getOptionValue(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };

  if (error) {
    parameter.error = error;
  }
  dataLayerSendEvent(eventName, parameter);
};

export const upcomingCardClick = (screenName, type) => {

  const getMyAsterCategory = () => {
    if(type === 'Appointment') {
       return MY_ASTER_CATEGORY?.DOCTOR_CONSULT;
    } else if (type === 'Home') {
      return MY_ASTER_CATEGORY?.HC;
    } else {
      return MY_ASTER_CATEGORY?.AE;
    }
  };

  const getType = () => {
    if (type === 'Appointment') {
      return 'appointment';
    } else if (type === 'Home') {
      return 'homecare services';
    } else {
      return 'shipment';
    }
  };

  const parameter = {
    screen_name: screenName,
    page_type: PAGE_TYPE?.HOME,
    card_type: getType(),
    myaster_category: getMyAsterCategory(),
  };
  dataLayerSendEvent('upcoming_card_click', parameter);
};

export const viewAllLinkClick = (screen, title, pageId = '') => {

  const getScreenName = () => {
    if (screen === 'Aster Core Home' || screen === 'Core') {
      return SCREEN_NAME?.ASCO;
    } else {
      return SCREEN_NAME?.AT;
    }
  };

  const getType = () => {
    if (title === 'Doctors By Specialty') {
      return 'speciality';
    } else if (title === 'Near You') {
      return 'facility';
    }
  };

  const parameter = {
    screen_name: getScreenName(),
    page_type: PAGE_TYPE?.HOME,
    page_id: pageId,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    section_name: title,
    type: getType(),
  };
  dataLayerSendEvent('view_all_link_click', parameter);
};

export const dataLayerMenuClick = (screenName, pageType, clickedMenu, location) => {

  const parameter = {
    screen_name: screenName,
    page_type: pageType,
    clicked_menu: clickedMenu,
    location: location,
  };
  dataLayerSendEvent('menu_click', parameter);
};

export const dataLayerMenuClickEvent = (screenName, pageType, clickedMenu, pathname) => {
  const parameter = {
    screen_name: screenName,
    page_type: pageType,
    clicked_menu: clickedMenu,
    myaster_category: getMyAsterCategory(pathname),
  };
  dataLayerSendEvent('menu_click', parameter);
};
